<template>
  <div>
    <v-card style="padding: 20px">
      <v-form ref="form">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>
          <v-select
            autofocus
            @change="changeChannelCount"
            :items="[...availableChannelCount, localChannelCount]"
            v-model="localChannelCount"
            label="Channel count"
            :disabled="disableChannelCountEdit"
          ></v-select>
          <v-layout row
                    wrap
          >
            <v-flex xs-1>
              <v-list dense>
                <template v-for="(channel, index) in channels">
                  <v-list-item :key="'channel-' + index">
                    Track {{ index + 1 }}
                  </v-list-item>
                </template>
              </v-list>
            </v-flex>
            <v-flex xs-4>
              <v-list dense>
                <draggable v-model="channels"
                           handle=".handle"
                >
                  <transition-group>
                    <template v-for="(channel, index) in channels">
                      <v-list-item :key="'channel-' + index">
                        <v-list-item-content>
                          {{ channel }}
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-icon class="handle pr-6">mdi-reorder-horizontal</v-icon>
                        </v-list-item-icon>
                      </v-list-item>
                    </template>
                  </transition-group>
                </draggable>
              </v-list>
            </v-flex>
          </v-layout>
          
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions>
          <div class="row row--end">
            <v-btn text
                   @click="$emit('cancel')"
            >Cancel </v-btn>
            <v-btn
              text
              color="primary"
              @click="clickAction(localChannelCount, localMapping)"
            >
              {{ title }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

const labels = ["L", "R", "C", "LFE", "Ls", "Rs"];

export default {
  name:       "SurroundChannelMappingForm",
  components: {
    draggable
  },
  props: {
    title:                   String,
    surroundChannelMappings: Object,
    channelCount:            Number,
    mapping:                 Object,
    clickAction:             Function,
    disableChannelCountEdit: Boolean,
  },
  data: function() {
    return {
      localChannelCount:     0,
      channels:              [],
      availableChannelCount: []
    };
  },
  watch: {
    'mapping': (newMapping) => {
      const channels = Array(this.localChannelCount).fill(null);
      this.channels = Object.entries(newMapping).reduce((ch, [label, track]) => {
        ch[track] = labels.find(l => l.toLowerCase() === label);
        return ch;
      }, channels);
    },
    'surroundChannelMappings': (newSurroundChannelMappings) => {
      const definedMappings = Object.keys(newSurroundChannelMappings).map(x => Number.parseInt(x));

      this.availableChannelCount = Array.from({length: 19}, (_, i) => i + 6) // [6, 7, 8, 9, ... 22, 23, 24]
        .filter(x => !definedMappings.includes(x));
    }
  },
  computed: {
    localMapping() {
      return this.channels.reduce((acc, track, idx) => { if (track) acc[track.toLowerCase()] = idx; return acc; }, {});
    }
  },
  mounted() {
    const definedMappings = Object.keys(this.surroundChannelMappings).map(x => Number.parseInt(x));
    this.availableChannelCount = Array.from({length: 19}, (_, i) => i + 6) // [6, 7, 8, 9, ... 22, 23, 24]
      .filter(x => !definedMappings.includes(x));

    this.localChannelCount = this.disableChannelCountEdit ? this.channelCount : this.availableChannelCount[0];

    const channels = Array(this.localChannelCount).fill(null);
    this.channels = Object.entries(this.mapping)
      .reduce((ch, [label, track]) => {
        ch[track] = labels.find(l => l.toLowerCase() === label);
        return ch;
      }, channels);
  },
  methods: {
    changeChannelCount(newChannelCount) {
      var newChannels = Array.from(labels);
      while (newChannels.length < newChannelCount)
        newChannels.push(null);

      this.channels = newChannels;
    }
  }
};
</script>

<style scoped>
  .handle {
    cursor: all-scroll;
  }
</style>
